import gql from 'graphql-tag';

import { Content } from './content';

export default gql`
  fragment ContentEmailHistory on ContentEmailHistory {
    spec_id
    sent_at
    spec {
      ...ContentEmailSpec
    }
    registered_user_count
    unregistered_user_count
    total_opened
    total_emails
    total_delivered
    total_clicks
    featured_content {
      ...Content
    }
  }
  ${Content}
`;
